import useFeatureFlag, { FeatureFlag } from '../../hooks/useFeatureFlag';
import type { CrawlerCategoryScheme } from './Crawlers';

export function useCrawlerCategoryScheme(): CrawlerCategoryScheme {
  return useFeatureFlag([FeatureFlag.CrawlerCategoriesNoGemini]) ? 'without-gemini' : 'with-gemini';
}
